import { render } from "./PassportScanner.vue?vue&type=template&id=67ec2b38&scoped=true"
import script from "./PassportScanner.vue?vue&type=script&lang=js"
export * from "./PassportScanner.vue?vue&type=script&lang=js"

import "./PassportScanner.vue?vue&type=style&index=0&id=67ec2b38&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ec2b38"]])

export default __exports__